import { styled, Box, useTheme } from "@mui/material";
import { IsDevice } from "../utils";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ProgressStep } from "./ProgressStep/ProgressStep";
import { TelephoneInfo } from "./TelephoneInfo/TelephoneInfo";

export const GenericContainer = ({ children, isCameraComponent = false }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();
  const contactInfo = useSelector((state) => state.ContactInfo);
  const fileInfo = useSelector((state) => state.FileInfo);
  const [contactInfoData, setContactInfoData] = useState(null);

  const isLogin = window.location.pathname.includes("login");

  /* useEffect(() => {
    sessionStorage.getItem("token") &&
      dispatch(
        fileActions.GetContactInfo({ File_Id: location.state?.folioId })
      );
  }, []); */

  useEffect(() => {
    if (contactInfo?.items != null) {
      setContactInfoData(contactInfo.items);
    } else {
    }
  }, [contactInfo]);

  const showProgressStep = () => {
    if (isLogin) return false;
    if (!!!fileInfo?.items?.WorkFlow?.StageGroups) return false;
    if (!!!fileInfo?.items?.Stage?.StageGroupSequence) return false;
    return true;
  };

  const showContactInfo = () => {
    if (isLogin) return false;
    if (!!!contactInfoData) return false;
    if (!!!contactInfoData?.MostrarInformacionContacto) return false;
    return true;
  };

  return (
    <>
      <Box
        sx={{
          WebkitAppearance: "none !important",
          background: theme.palette.primary.mainLyrics,
          margin: "0px",
          marginBottom: "0px",
          minHeight: "calc(100vh - 70px)",
          overflowY: "auto !important",
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "left",
          ...(isCameraComponent && { justifyContent: "start" }),
          overflowX: "hidden !important",
          WebkitOverflowScrolling: "auto !important",
          width: "100%",
          [theme.breakpoints.only("xs")]: {
            padding: "3px 0.5em",
          },
          [theme.breakpoints.only("sm")]: {
            padding: "3px 0.5em",
          },
          [theme.breakpoints.only("md")]: {
            padding: isCameraComponent ? "5px 1em" : "5px 7em",
          },
          [theme.breakpoints.only("lg")]: {
            padding: isCameraComponent ? "6px 1em" : "6px 9em",
          },
          [theme.breakpoints.only("xl")]: {
            padding: isCameraComponent ? "8px 1em" : "8px 11em",
          },
        }}
      >
        {showProgressStep() && (
          <ProgressStep
            stepperData={fileInfo?.items?.WorkFlow?.StageGroups}
            currentStep={fileInfo?.items?.Stage?.StageGroupSequence ?? 1}
          />
        )}
        {children}
      </Box>
      {showContactInfo() && (
        <TelephoneInfo
          description={"¿Dudas? Comunícate"}
          telephoneData={{
            title: "Teléfono HSBC",
            textDescription: contactInfoData?.DescripcionContacto,
            number: contactInfoData?.TelefonoContacto,
          }}
        />
      )}
    </>
  );
};

export const GenericContainerCenter = styled(Box)(({ theme, dynamicSize }) => ({
  background: theme.palette.primary.mainLyrics,
  margin: "0px",
  marginBottom: "0px",
  overflowY: "auto !important",
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "left",
  overflowX: "hidden !important",
  width: "100%",
  [theme.breakpoints.only("xs")]: {
    minHeight: `calc(100vh - ${
      dynamicSize || (IsDevice().IsMobile ? 250 : 195)
    }px)`,
  },
  [theme.breakpoints.only("sm")]: {
    minHeight: `calc(100vh - ${dynamicSize || 190}px)`,
  },
  [theme.breakpoints.only("md")]: {
    minHeight: `calc(100vh - ${dynamicSize || 160}px)`,
  },
  [theme.breakpoints.only("lg")]: {
    minHeight: `calc(100vh - ${dynamicSize || 155}px)`,
  },
  [theme.breakpoints.only("xl")]: {
    minHeight: `calc(100vh - ${dynamicSize || 150}px)`,
  },
}));

export const GenericContainerForm = styled(Box)(({ theme, dynamicSize }) => ({
  background: theme.palette.primary.mainLyrics,
  margin: "0px",
  marginBottom: "0px",
  overflowY: "auto !important",
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "left",
  overflowX: "hidden !important",
  width: "100%",
  [theme.breakpoints.only("xs")]: {
    minHeight: `calc(100vh - ${
      dynamicSize || (IsDevice().IsIOS ? 300 : 290)
    }px)`,
  },
  [theme.breakpoints.only("sm")]: {
    minHeight: `calc(100vh - ${dynamicSize || 280}px)`,
  },
  [theme.breakpoints.only("md")]: {
    minHeight: `calc(100vh - ${dynamicSize || 250}px)`,
  },
  [theme.breakpoints.only("lg")]: {
    minHeight: `calc(100vh - ${dynamicSize || 245}px)`,
  },
  [theme.breakpoints.only("xl")]: {
    minHeight: `calc(100vh - ${dynamicSize || 240}px)`,
  },
}));

export const GenericContainerImage = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignContent: "center",
  alignItems: "center",
  overflow: "hidden",
  textAlign: "center",
  justifyContent: "center",
  [theme.breakpoints.only("xs")]: {
    height: "58vh",
  },
  [theme.breakpoints.only("sm")]: {
    height: "55vh",
  },
  [theme.breakpoints.only("md")]: {
    height: "55vh",
  },
  [theme.breakpoints.only("lg")]: {
    height: "60vh",
  },
  [theme.breakpoints.only("xl")]: {
    height: "70vh",
  },
}));

export const GenericContainerConfirm = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.mainLyrics,
  margin: "0px",
  marginBottom: "0px",
  overflowY: "auto !important",
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "left",
  overflowX: "hidden !important",
  width: "100%",
  [theme.breakpoints.only("xs")]: {
    padding: "3px 0.5em",
    height: "58vh",
  },
  [theme.breakpoints.only("sm")]: {
    padding: "3px 0.5em",
    height: "52vh",
  },
  [theme.breakpoints.only("md")]: {
    padding: "5px 7em",
    height: "30vh",
  },
  [theme.breakpoints.only("lg")]: {
    padding: "6px 9em",
    height: "33vh",
  },
  [theme.breakpoints.only("xl")]: {
    padding: "8px 11em",
    height: "38vh",
  },
}));
